import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../../Atoms/Typography'
import Button from '../../../Atoms/Button'

import theme from '../../../../styles/theme'

const Container = styled(View)`
  padding: ${3 * theme.gutterUnit}px ${3 * theme.gutterUnit}px ${theme.gutterUnit}px ${3 * theme.gutterUnit}px;
  background-color: ${theme.colours.white};
`

const Row = styled(View)`
  flex-direction: row;
  margin-top: ${3 * theme.gutterUnit}px;
`

const StyledButton = styled(Button)`
  border-radius: 5px;
  border-color: ${theme.colours.black};
  border-width: 2px;
  background-color: ${props => props.active ? theme.colours.black : theme.colours.white};
  height: 60px;
  width: 60px
  padding: ${theme.gutterUnit}px;
`

const ButtonContainer = styled(View)`
  flex-direction: column;
  align-items: center;
  margin-right: ${2 * theme.gutterUnit}px;
`

const FontButton = ({ active, label, value, onPress }) => {
  return (
    <ButtonContainer>
      <StyledButton
        active={active} onPress={() => {
          onPress(value)
        }}
      >
        <Text size='l' primary={active}>aA</Text>
      </StyledButton>
      <Text
        size='s' overrides={{
          marginTop: theme.gutterUnit
        }}
      >{label}
      </Text>
    </ButtonContainer>
  )
}

export default class FontSelection extends PureComponent {
  render () {
    const { sideBarFontSize, onSideBarFontSizeSelect } = this.props
    return (
      <Container>
        <Text bold>SELECT MENU LABEL FONT SIZE</Text>
        <Row>
          <FontButton
            active={sideBarFontSize === 's'}
            label='Small'
            value='s'
            onPress={onSideBarFontSizeSelect}
          />
          <FontButton
            active={sideBarFontSize === 'm'}
            label='Medium'
            value='m'
            onPress={onSideBarFontSizeSelect}
          />
          <FontButton
            active={sideBarFontSize === 'l'}
            label='Large'
            value='l'
            onPress={onSideBarFontSizeSelect}
          />
        </Row>
      </Container>
    )
  }
}
